let timeInterval

export async function showTime() {
    if (location.pathname == "/") {
        let times = document.querySelector(".mv__innerBlockToday")

        function getTime() {
            let date = new Date()

            let h24 = date.getHours()
            let h12 = h24 % 12
            let min = date.getMinutes()
            let ampm = h24 < 12 ? "AM" : "PM"

            let mouths = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December", ]
            let month = mouths[date.getMonth()]
            let dateNum = date.getDate()
            let year = date.getFullYear()

            times.querySelector(".hour").innerHTML = h12.toString().padStart(2, "0")
            times.querySelector(".min").innerHTML = min.toString().padStart(2, "0")
            times.querySelector(".ampm").innerHTML = ampm

            times.querySelector(".month").innerHTML = month
            times.querySelector(".date").innerHTML = dateNum.toString().padStart(2, "0")
            times.querySelector(".year").innerHTML = year
        }
        getTime()
        timeInterval = setInterval(getTime, 3000)
    } else {
        clearInterval(timeInterval)
    }
}